import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/teacheraccount/details/loadscreenview", { ...vo }, successCallback, failureCallback);
    },
    addTeacherAccount: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/teacheraccount/details/createteacher", vo, successCallback, failureCallback);
    },
    savePassword: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/teacheraccount/details/savepassword", vo, successCallback, failureCallback);
    }
};

export default EditService;